module.exports = __webpack_public_path__ + "img/Engagement_Highly_Engaged_32@2x.3d94cb21.png";